// extracted by mini-css-extract-plugin
module.exports = {"container":"Badge_container__eLaay","md":"Badge_md__gAZma","gray":"Badge_gray__VNn-S","primary":"Badge_primary__21Olm","sending":"Badge_sending__35sFP"};